import { Component, Output, EventEmitter } from "@angular/core";

@Component({
  selector: 'app-exportar-btn',
  templateUrl: './exportar-btn.component.html',
  styleUrls: ['./exportar-btn.component.scss'],
})
export class ExportarBtnComponent {

  @Output() onExportacaoSolicitada = new EventEmitter();

  /**
   * Indicador que define se os tipos de exportacao devem ser exibidos
   */
  exibirTipoExportacao: boolean = false;

  /**
   * Alterna a exibicao do tipo de exportacao
   */
  toogleTipoExportacao() {
    this.exibirTipoExportacao = !this.exibirTipoExportacao;
  }

  exportar(tipoExportacao: string) {
    this.onExportacaoSolicitada.emit(tipoExportacao);
  }

}


// WEBPACK FOOTER //
// ./src/app/components/exportar/exportar-btn.component.ts